import {Skeleton} from '@ds/components';

const ProductListItemSkeleton: React.FC = () => {
  return (
    <div className="flex w-full flex-col gap-1 border-b border-gray-03 px-4 py-2">
      <Skeleton active paragraph={{rows: 0}} title={{width: '70%'}} />
      <div className="flex items-start justify-between">
        <Skeleton.Button active size="small" className="h-5! w-15!" />
        <Skeleton.Button active size="small" className="h-5! w-12.5!" />
      </div>
      <div className="flex items-center gap-2">
        <Skeleton.Button active size="small" className="h-4! w-20!" />
        <Skeleton.Button active size="small" className="h-5! w-10!" />
      </div>
    </div>
  );
};

export default ProductListItemSkeleton;
